/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConfirmAccountRequest,
  CreateAccountRequest,
  ErrorModel,
  ExchangeCodeForTokensRequest,
  LoginAccountRequest,
  LoginResponse,
  RefreshTokensRequest,
  ResetPasswordWithTokenRequest,
  RespondToAuthChallengeRequest,
  SendForgotPasswordEmailRequest,
  Tokens,
} from '../models/index';
import {
    ConfirmAccountRequestFromJSON,
    ConfirmAccountRequestToJSON,
    CreateAccountRequestFromJSON,
    CreateAccountRequestToJSON,
    ErrorModelFromJSON,
    ErrorModelToJSON,
    ExchangeCodeForTokensRequestFromJSON,
    ExchangeCodeForTokensRequestToJSON,
    LoginAccountRequestFromJSON,
    LoginAccountRequestToJSON,
    LoginResponseFromJSON,
    LoginResponseToJSON,
    RefreshTokensRequestFromJSON,
    RefreshTokensRequestToJSON,
    ResetPasswordWithTokenRequestFromJSON,
    ResetPasswordWithTokenRequestToJSON,
    RespondToAuthChallengeRequestFromJSON,
    RespondToAuthChallengeRequestToJSON,
    SendForgotPasswordEmailRequestFromJSON,
    SendForgotPasswordEmailRequestToJSON,
    TokensFromJSON,
    TokensToJSON,
} from '../models/index';

export interface ConfirmAccountOperationRequest {
    confirmAccountRequest: Omit<ConfirmAccountRequest, '$schema'>;
}

export interface CreateAccountOperationRequest {
    createAccountRequest: Omit<CreateAccountRequest, '$schema'>;
}

export interface ExchangeCodeForTokensOperationRequest {
    exchangeCodeForTokensRequest: Omit<ExchangeCodeForTokensRequest, '$schema'>;
    origin?: string;
}

export interface LoginAccountOperationRequest {
    loginAccountRequest: Omit<LoginAccountRequest, '$schema'>;
}

export interface RefreshTokensOperationRequest {
    refreshTokensRequest: Omit<RefreshTokensRequest, '$schema'>;
}

export interface ResetPasswordWithTokenOperationRequest {
    resetPasswordWithTokenRequest: Omit<ResetPasswordWithTokenRequest, '$schema'>;
}

export interface RespondToAuthChallengeOperationRequest {
    respondToAuthChallengeRequest: Omit<RespondToAuthChallengeRequest, '$schema'>;
}

export interface SendForgotPasswordEmailOperationRequest {
    sendForgotPasswordEmailRequest: Omit<SendForgotPasswordEmailRequest, '$schema'>;
}

/**
 * 
 */
export class AuthenticationApi extends runtime.BaseAPI {

    /**
     * Creates request options for confirmAccount without sending the request
     */
    async confirmAccountRequestOpts(requestParameters: ConfirmAccountOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['confirmAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'confirmAccountRequest',
                'Required parameter "confirmAccountRequest" was null or undefined when calling confirmAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/authentication/confirm`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmAccountRequestToJSON(requestParameters['confirmAccountRequest']),
        };
    }

    /**
     * Confirm account
     * Confirm Account
     */
    async confirmAccountRaw(requestParameters: ConfirmAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>> {
        const requestOptions = await this.confirmAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * Confirm account
     * Confirm Account
     */
    async confirmAccount(requestParameters: ConfirmAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse> {
        const response = await this.confirmAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createAccount without sending the request
     */
    async createAccountRequestOpts(requestParameters: CreateAccountOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'createAccountRequest',
                'Required parameter "createAccountRequest" was null or undefined when calling createAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/authentication/create`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAccountRequestToJSON(requestParameters['createAccountRequest']),
        };
    }

    /**
     * Create account
     * Create Account
     */
    async createAccountRaw(requestParameters: CreateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.createAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Create account
     * Create Account
     */
    async createAccount(requestParameters: CreateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for exchangeCodeForTokens without sending the request
     */
    async exchangeCodeForTokensRequestOpts(requestParameters: ExchangeCodeForTokensOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['exchangeCodeForTokensRequest'] == null) {
            throw new runtime.RequiredError(
                'exchangeCodeForTokensRequest',
                'Required parameter "exchangeCodeForTokensRequest" was null or undefined when calling exchangeCodeForTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['origin'] != null) {
            headerParameters['origin'] = String(requestParameters['origin']);
        }


        let urlPath = `/authentication/tokens`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExchangeCodeForTokensRequestToJSON(requestParameters['exchangeCodeForTokensRequest']),
        };
    }

    /**
     * Exchange code for tokens
     * Exchange Code For Tokens
     */
    async exchangeCodeForTokensRaw(requestParameters: ExchangeCodeForTokensOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tokens>> {
        const requestOptions = await this.exchangeCodeForTokensRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokensFromJSON(jsonValue));
    }

    /**
     * Exchange code for tokens
     * Exchange Code For Tokens
     */
    async exchangeCodeForTokens(requestParameters: ExchangeCodeForTokensOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tokens> {
        const response = await this.exchangeCodeForTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for loginAccount without sending the request
     */
    async loginAccountRequestOpts(requestParameters: LoginAccountOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['loginAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'loginAccountRequest',
                'Required parameter "loginAccountRequest" was null or undefined when calling loginAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/authentication/login`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginAccountRequestToJSON(requestParameters['loginAccountRequest']),
        };
    }

    /**
     * Login
     * Login
     */
    async loginAccountRaw(requestParameters: LoginAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>> {
        const requestOptions = await this.loginAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * Login
     * Login
     */
    async loginAccount(requestParameters: LoginAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse> {
        const response = await this.loginAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for refreshTokens without sending the request
     */
    async refreshTokensRequestOpts(requestParameters: RefreshTokensOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['refreshTokensRequest'] == null) {
            throw new runtime.RequiredError(
                'refreshTokensRequest',
                'Required parameter "refreshTokensRequest" was null or undefined when calling refreshTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/authentication/refresh`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefreshTokensRequestToJSON(requestParameters['refreshTokensRequest']),
        };
    }

    /**
     * Refresh tokens
     * Refresh Tokens
     */
    async refreshTokensRaw(requestParameters: RefreshTokensOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>> {
        const requestOptions = await this.refreshTokensRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * Refresh tokens
     * Refresh Tokens
     */
    async refreshTokens(requestParameters: RefreshTokensOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse> {
        const response = await this.refreshTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resetPasswordWithToken without sending the request
     */
    async resetPasswordWithTokenRequestOpts(requestParameters: ResetPasswordWithTokenOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['resetPasswordWithTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'resetPasswordWithTokenRequest',
                'Required parameter "resetPasswordWithTokenRequest" was null or undefined when calling resetPasswordWithToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/authentication/reset-password`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordWithTokenRequestToJSON(requestParameters['resetPasswordWithTokenRequest']),
        };
    }

    /**
     * Reset password with token
     * Reset Password With Token
     */
    async resetPasswordWithTokenRaw(requestParameters: ResetPasswordWithTokenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>> {
        const requestOptions = await this.resetPasswordWithTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * Reset password with token
     * Reset Password With Token
     */
    async resetPasswordWithToken(requestParameters: ResetPasswordWithTokenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse> {
        const response = await this.resetPasswordWithTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for respondToAuthChallenge without sending the request
     */
    async respondToAuthChallengeRequestOpts(requestParameters: RespondToAuthChallengeOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['respondToAuthChallengeRequest'] == null) {
            throw new runtime.RequiredError(
                'respondToAuthChallengeRequest',
                'Required parameter "respondToAuthChallengeRequest" was null or undefined when calling respondToAuthChallenge().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/authentication/respond`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RespondToAuthChallengeRequestToJSON(requestParameters['respondToAuthChallengeRequest']),
        };
    }

    /**
     * Respond to auth challenge
     * Respond to Auth Challenge
     */
    async respondToAuthChallengeRaw(requestParameters: RespondToAuthChallengeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>> {
        const requestOptions = await this.respondToAuthChallengeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * Respond to auth challenge
     * Respond to Auth Challenge
     */
    async respondToAuthChallenge(requestParameters: RespondToAuthChallengeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse> {
        const response = await this.respondToAuthChallengeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sendForgotPasswordEmail without sending the request
     */
    async sendForgotPasswordEmailRequestOpts(requestParameters: SendForgotPasswordEmailOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sendForgotPasswordEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'sendForgotPasswordEmailRequest',
                'Required parameter "sendForgotPasswordEmailRequest" was null or undefined when calling sendForgotPasswordEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/authentication/forgot-password`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendForgotPasswordEmailRequestToJSON(requestParameters['sendForgotPasswordEmailRequest']),
        };
    }

    /**
     * Send forgot password email
     * Send Forgot Password Email
     */
    async sendForgotPasswordEmailRaw(requestParameters: SendForgotPasswordEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.sendForgotPasswordEmailRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Send forgot password email
     * Send Forgot Password Email
     */
    async sendForgotPasswordEmail(requestParameters: SendForgotPasswordEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.sendForgotPasswordEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
